<template>
  <div class="agent-wrapper">

    <agent-filter-form
      v-if="hasRes('agent_index')"
      @filter="updateTableData" />

    <custom-table
      v-if="hasRes('agent_index')"
      :data="agentList"
      @data-change="updateTableData">
      <el-table-column
        prop="agentid"
        label="代理商ID"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column
        prop="agentname"
        label="代理商名称"
        sortable="custom"
        align="center"
        header-align="center" >
      </el-table-column>

      <el-table-column label="操作"
        align="center"
        width="200"
        header-align="center"
        v-if="hasResCate('store')">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="onManageAppClick(scope.row)">应用管理</el-button>
        </template>
      </el-table-column>
    </custom-table>

    <custom-paginate
      :count="agentCount"
      v-if="hasRes('agent_index')"
      @page-change="updateTableData" />

    <dialog-manage-app
      owner-type="agent"
      :owner="owner"
      :owner-app-list="agentAppList"
      :visible.sync="manageAppDialogVisible"
      @add-app="addUserOrAgentAppDialogVisible = true"
      @edit-app="onAppEditClick"
      @data-change="refreshOwnerApp" />

    <dialog-add-user-or-agent-app
      :owner="owner"
      owner-type="agent"
      :existed-owner-app-list="agentAppList"
      :visible.sync="addUserOrAgentAppDialogVisible"
      @data-change="refreshOwnerApp" />

    <dialog-edit-agent-app
      @data-change="refreshOwnerApp"
      :editing-agent-app="editingAgentApp"
      :visible.sync="editAgentAppDialogVisible" />

  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'
import AgentFilterForm from '@/components/user/AgentFilterForm'
import DialogManageApp from '@/pages/op/store/components/DialogManageApp'
import DialogAddUserOrAgentApp from '@/pages/op/store/components/DialogAddUserOrAgentApp'
import DialogEditAgentApp from '@/pages/op/store/components/DialogEditAgentApp'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_LOADING } from '@/store/modules/table'

export default {
  name: 'Agent',
  components: {
    CustomTable,
    CustomPaginate,
    AgentFilterForm,
    DialogManageApp,
    DialogAddUserOrAgentApp,
    DialogEditAgentApp
  },
  data () {
    return {
      manageAppDialogVisible: false,
      owner: {},

      addUserOrAgentAppDialogVisible: false,

      editAgentAppDialogVisible: false,
      editingAgentApp: {}
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'sort',
      'filters',
      'loading'
    ]),
    ...mapState('agent', [
      'agentList',
      'agentCount'
    ]),
    ...mapState('store', [
      'agentAppList'
    ]),
    ...mapGetters('opUser', [
      'hasResCate',
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_LOADING
    ]),
    ...mapActions('agent', [
      'getAgents'
    ]),
    ...mapActions('store', [
      'getAgentApps'
    ]),

    async onManageAppClick (agent) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载代理商应用',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        await this.getAgentApps({
          page: 1,
          pageSize: 9999,
          condition: {
            agentid: agent.agentid
          }
        })

        this.owner = agent
        this.manageAppDialogVisible = true
      } catch (err) {
        console.log(err)
      }
      loading.close()
    },
    async refreshOwnerApp () {
      try {
        await this.getAgentApps({
          page: 1,
          pageSize: 9999,
          condition: {
            agentid: this.owner.agentid
          }
        })
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取代理商应用失败'
        })
      }
    },
    onAppEditClick (agentApp) {
      this.editingAgentApp = agentApp
      this.editAgentAppDialogVisible = true
    },

    updateTableData () {
      if (!this.hasRes('agent_index')) return

      this.setLoading(true)

      this.getAgents({
        page: this.page,
        pageSize: this.pageSize,
        sort: this.sort,
        filters: this.filters
      }).then(res => {
        this.setLoading(false)
      }).catch(err => {
        console.log(err)
        this.setLoading(false)

        this.$message({
          type: 'error',
          message: '获取代理商列表失败'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/op/user/Agent.vue